module.exports = __webpack_public_path__ + "img/0220624174231.44bd1fac.png";